import { createUseStyles } from 'react-jss'
import { THEME } from 'components/theme'

const colorObject = {
  primary: THEME.brandGreen,
  secondary: THEME.brandYellow,
  danger: THEME.brandRed,
  default: THEME.brandBlack,
  tertiary: THEME.brandLinkBlue,
  grayscale: THEME.infoGrey
}

type PropType = {
  fontWeight: string | number
  fontColor: 'primary' | 'secondary' | 'danger' | 'default' | 'tertiary' | 'grayscale'
  fontSize?: string | number
}
export const styles = createUseStyles({
  fontStyle: {
    fontWeight: (props: PropType) => props.fontWeight,
    color: (props: PropType) => colorObject[props.fontColor || 'default'],
    fontSize: (props: PropType) => props.fontSize || 'inherit'
  }
})
